import React from 'react';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import CapitalBalanceListView from './components/CapitalBalanceListView';
import { ACCOUNTING_CAPITAL_BALANCE_CONFIG } from './config';

const AccountingCapitalBalanceListPage = () => (
  <CapitalBalanceListView config={ACCOUNTING_CAPITAL_BALANCE_CONFIG} />
);

const AccountingCapitalBalanceView = () => {
  return (
    <>
      <RolePrivateRoute
        component={AccountingCapitalBalanceListPage}
      />
    </>
  );
};


export default AccountingCapitalBalanceView;
